var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "TURKEY_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000178201943115259673320000000077161886034352303_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "#D00027"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000178201943115259673320000000077161886034352303__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_43318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.3041 5.55859C13.0071 5.55859 15.2001 7.74961 15.2001 10.4536C15.2001 13.1566 13.0071 15.3486 10.3041 15.3486C7.60213 15.3486 5.41113 13.1576 5.41113 10.4536C5.41113 7.74961 7.60213 5.55859 10.3041 5.55859Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.5264 6.53516C13.6914 6.53516 15.4424 8.29316 15.4424 10.4532C15.4424 12.6172 13.6914 14.3712 11.5264 14.3712C9.36435 14.3712 7.61035 12.6172 7.61035 10.4532C7.61035 8.29316 9.36435 6.53516 11.5264 6.53516Z",
    fill: "#D00027"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.4404 10.453L16.7654 11.211L17.1434 10.043L14.4404 10.453Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.4404 10.4532L16.7654 9.69922L17.1434 10.8632L14.4404 10.4532Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M16.1309 8.125V10.574H17.3539L16.1309 8.125Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M16.1309 8.125L17.5679 10.105L16.5809 10.824L16.1309 8.125Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M16.1309 12.785L17.5679 10.801L16.5809 10.082L16.1309 12.785Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M16.1309 12.785V10.332H17.3539L16.1309 12.785Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M18.866 9.02051L16.542 9.77051L16.92 10.9345L18.866 9.02051Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M18.8655 9.02051L17.4285 10.9965L16.4365 10.2775L18.8655 9.02051Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M18.8655 11.8951L17.4285 9.91406L16.4365 10.6331L18.8655 11.8951Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_43318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000048494732468886146680000014577863921072417158__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M34.0777 0.664062H0.514648V20.2461H34.0777V0.664062Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_43318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M18.866 11.8947L16.542 11.1367L16.92 9.97266L18.866 11.8947Z",
    fill: "white"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/TURKEY.8d46f34fa186949bb976772539fd9602.svg";
export { ForwardRef as ReactComponent };